import { t } from '@lingui/core/macro'

export type MetadataUserEditSaveContext = {
  editedBy: string
  siteID: string
  orgID: string
}

/** Require user email + site/org before a metadata user-edit save. */
export function resolveMetadataUserEditSaveContext({
  userEmail,
  siteID,
  orgID,
  surface,
  errorNotification,
}: {
  userEmail: string | undefined
  siteID: string | undefined
  orgID: string | undefined
  surface: 'document' | 'page'
  errorNotification: (message: string) => void
}): MetadataUserEditSaveContext {
  const editedBy = userEmail?.trim()
  if (!editedBy) {
    errorNotification(t`Unable to determine current user for edit`)
    throw new Error(`Missing user email for ${surface} metadata edit`)
  }
  if (!siteID || !orgID) {
    errorNotification(t`Missing site or organization for edit`)
    throw new Error(`Missing site/org for ${surface} metadata edit`)
  }
  return { editedBy, siteID, orgID }
}
